<div><span class="clickable" (click)="onClick($event)">{{prompt.text}}</span>
    <mat-icon
        *ngIf="prompt.infoToolTip"
        [ngClass]="{'clickable': prompt.infoClickCallBack !== undefined}"
        (click)="infoToolTipClick($event)"
        [matTooltip]="prompt.infoToolTip">info_outline</mat-icon></div>
<app-render-html class="clickable" [html]="prompt.html" (click)="onClick($event)"></app-render-html>